import { injectable } from "tsyringe";
import { HouseholdExclusion } from "src/containers/household/domain/exclusion";
import { HouseholdCoverage } from "src/containers/household/domain/coverage";
import coverages from "src/containers/household/core/data/coverages.json";
import exclusions from "src/containers/household/core/data/exclusions.json";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class HouseholdCoverageViewModel {
    private coverages: HouseholdCoverage[];
    private exclusions: HouseholdExclusion[];

    constructor() {
        this.coverages = coverages.map((c) => HouseholdCoverage.fromJson(c));
        this.exclusions = exclusions.map((e) => HouseholdExclusion.fromJson(e));
    }

    @autoBind
    getCoverage(coverageId: string): HouseholdCoverage | undefined {
        return this.coverages.find((c) => c.id === coverageId);
    }

    @autoBind
    getExclusion(exclusionId: string): HouseholdExclusion | undefined {
        return this.exclusions.find((c) => c.id === exclusionId);
    }
}
